import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { UserProfileForm } from '.';

export const useUserProfileFormContext = ():
  | UseFormReturn<UserProfileForm>
  | never => {
  const form = useFormContext<UserProfileForm>();

  if (form === null)
    throw AppError.hookScopeError(
      'useUserProfileFormContext can only be used inside a User Profile Form Context Provider.',
    );

  return form;
};
